import { Collapse, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import ButtonWrapper from './styles/ButtonWrapper';
import { DEFAULT_FILTERS, statuses } from '../constants/filters';
import MultipleSelect from '../../../../../../shared/ui/MultipleSelect';

function Filters({ filters, setFilters, setPage, isOpen }) {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleResetFilters = () => {
    setLocalFilters(DEFAULT_FILTERS);
  };

  const handleFilter = () => {
    setFilters(localFilters);
    setPage(0);
  };

  const handleChange = (event) => {
    setLocalFilters((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  return (
    <Collapse in={isOpen}>
      <Container>
        <Wrapper>
          <TextField
            size="small"
            label="Название задачи"
            fullWidth
            name="taskName"
            value={localFilters.taskName}
            onChange={handleChange}
          />

          <MultipleSelect
            label="Статусы"
            name="statuses"
            items={statuses}
            value={localFilters.statuses}
            onChange={handleChange}
          />
        </Wrapper>
      </Container>

      <ButtonWrapper>
        <Button onClick={handleResetFilters} variant="text">
          Сбросить
        </Button>
        <Button onClick={() => handleFilter(filters)} variant="contained">
          Поиск
        </Button>
      </ButtonWrapper>
    </Collapse>
  );
}

Filters.propTypes = {
  filters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  setFilters: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default Filters;
